module.exports = __webpack_public_path__ + "static/media/Snowboarder Male.03844eb2.jpg";